import React from 'react'

const DocSearchGroupRow = (props) => {
    const { viewData } = props;

    let cssStyle = viewData.cssStyle ? JSON.parse(viewData.cssStyle) : {};
    // let cssStyle = {};

    return (
        <>
            <span className="uiMenuItemLabel"
                style = {cssStyle}>
                {viewData.val}
            </span>
        </>
    )
}

export default DocSearchGroupRow